<div class="main-layout">
    <div class="header-container">
        <app-quotation-top-header></app-quotation-top-header>
        <app-quotation-header (collapsedState)="onHeaderCollapse($event)"></app-quotation-header>
    </div>

    <div class="content-wrapper" [class.expanded]="!isHeaderCollapsed" [class.collapsed]="isHeaderCollapsed">
        <div class="fixed-content">
            <h2>Quotation Status</h2>
            <div class="filter-container">
                <div class="custom-input-group">
                    <i class="pi pi-search filter-icon"></i>
                    <input pInputText type="text" [(ngModel)]="globalFilter" (input)="onGlobalFilter($event)"
                        placeholder="Search workflows..." class="filter-input" />
                </div>
                <button pButton type="button" label="Save Statuses" class="p-button-success"
                    (click)="saveStatuses()"></button>
            </div>
        </div>
        <div class="table-container">
            <p-table #table [value]="workflowItems" [globalFilterFields]="['data.jobNumber', 'data.project']"
                [tableStyle]="{'min-width': '75rem'}" [paginator]="true" [rows]="rowsPerPage"
                [rowsPerPageOptions]="rowsPerPageOptions" [totalRecords]="workflowItems.length"
                (onPage)="onPageChange($event)" styleClass="p-datatable-gridlines p-datatable-striped">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="data.jobNumber" rowspan="2" class="equal-width">
                            Job Number
                            <p-sortIcon field="data.jobNumber"></p-sortIcon>
                            <input pInputText type="text" (input)="onColumnFilter($event, 'data.jobNumber')"
                                placeholder="Filter" class="p-column-filter" />
                        </th>
                        <th pSortableColumn="data.project" rowspan="2" class="equal-width">
                            Project Name
                            <p-sortIcon field="data.project"></p-sortIcon>
                            <input pInputText type="text" (input)="onColumnFilter($event, 'data.project')"
                                placeholder="Filter" class="p-column-filter" />
                        </th>
                        <th rowspan="2" class="equal-width">Production Order Release</th>
                        <th rowspan="2" class="equal-width">Planning</th>
                        <th colspan="5">Workshop Status</th>
                        <th rowspan="2" class="equal-width">Packing</th>
                        <th rowspan="2" class="equal-width">Complete</th>
                    </tr>
                    <tr>
                        <th class="equal-width workshop-status-header">Shearing & Punching</th>
                        <th class="equal-width workshop-status-header">Bending</th>
                        <th class="equal-width workshop-status-header">Welding</th>
                        <th class="equal-width workshop-status-header">Powder Coating</th>
                        <th class="equal-width workshop-status-header">Assembling/Rubber Beading</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                    <tr>
                        <td class="equal-width">{{ item.data?.jobNumber || '-' }}</td>
                        <td class="equal-width">{{ item.data?.project || '-' }}</td>
                        <td class="equal-width selectable-cell" [ngClass]="getCellClass(rowIndex, 2)"
                            (click)="onCellClick(rowIndex, 2)">
                            {{ getCellContent(rowIndex, 2) }}
                        </td>
                        <td class="equal-width selectable-cell" [ngClass]="getCellClass(rowIndex, 3)"
                            (click)="onCellClick(rowIndex, 3)">
                            {{ getCellContent(rowIndex, 3) }}
                        </td>
                        <td class="equal-width selectable-cell" [ngClass]="getCellClass(rowIndex, 4)"
                            (click)="onCellClick(rowIndex, 4)">
                            {{ getCellContent(rowIndex, 4) }}
                        </td>
                        <td class="equal-width selectable-cell" [ngClass]="getCellClass(rowIndex, 5)"
                            (click)="onCellClick(rowIndex, 5)">
                            {{ getCellContent(rowIndex, 5) }}
                        </td>
                        <td class="equal-width selectable-cell" [ngClass]="getCellClass(rowIndex, 6)"
                            (click)="onCellClick(rowIndex, 6)">
                            {{ getCellContent(rowIndex, 6) }}
                        </td>
                        <td class="equal-width selectable-cell" [ngClass]="getCellClass(rowIndex, 7)"
                            (click)="onCellClick(rowIndex, 7)">
                            {{ getCellContent(rowIndex, 7) }}
                        </td>
                        <td class="equal-width selectable-cell" [ngClass]="getCellClass(rowIndex, 8)"
                            (click)="onCellClick(rowIndex, 8)">
                            {{ getCellContent(rowIndex, 8) }}
                        </td>
                        <td class="equal-width selectable-cell" [ngClass]="getCellClass(rowIndex, 9)"
                            (click)="onCellClick(rowIndex, 9)">
                            {{ getCellContent(rowIndex, 9) }}
                        </td>
                        <td class="equal-width selectable-cell" [ngClass]="getCellClass(rowIndex, 10)"
                            (click)="onCellClick(rowIndex, 10)">
                            {{ getCellContent(rowIndex, 10) }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="10">No workflow items available.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-toast></p-toast>